<mat-toolbar>
  <span>mmocld test client</span>
  <a mat-raised-button color="primary" class="navBtn-top" routerLink="/" routerLinkActive="active">home</a>
  <a mat-raised-button color="primary" class="navBtn-top" routerLink="/game" routerLinkActive="active">game</a>
  <a mat-raised-button color="primary" class="navBtn-top" routerLink="/simulator" routerLinkActive="active">
    simulator
  </a>
  <button mat-raised-button color="warn" class="logBtn" *ngIf="!isLoggedIn" (click)="onLogin()">login</button>
  <button mat-raised-button color="accent" class="logBtn" *ngIf="isLoggedIn" (click)="onLogout()">logout</button>
</mat-toolbar>
<mat-toolbar class="mobile-toolbar">
  <a mat-raised-button color="primary" class="navBtn" routerLink="/" routerLinkActive="active">home</a>
  <a mat-raised-button color="primary" class="navBtn" routerLink="/game" routerLinkActive="active">game</a>
  <a mat-raised-button color="primary" class="navBtn" routerLink="/simulator" routerLinkActive="active"> simulator </a>
</mat-toolbar>
